var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanUpgraded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 46.5L43.3214 62.3929L68.75 30.6071M46.5 91C40.6562 91 34.8696 89.849 29.4706 87.6126C24.0716 85.3763 19.166 82.0985 15.0337 77.9663C10.9015 73.834 7.6237 68.9284 5.38736 63.5294C3.15103 58.1304 2 52.3438 2 46.5C2 40.6562 3.15103 34.8696 5.38736 29.4706C7.6237 24.0716 10.9015 19.166 15.0337 15.0337C19.166 10.9015 24.0716 7.62369 29.4706 5.38736C34.8696 3.15103 40.6562 2 46.5 2C58.3021 2 69.6209 6.68838 77.9663 15.0337C86.3116 23.3791 91 34.6979 91 46.5C91 58.3021 86.3116 69.6209 77.9663 77.9663C69.6209 86.3116 58.3021 91 46.5 91Z",
    stroke: "#240b3b",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanUpgraded);
export default __webpack_public_path__ + "static/media/plan_upgraded.aa5ea1269e74d904594c1cea9dc4d7cf.svg";
export { ForwardRef as ReactComponent };